import { render } from "./EditForecast.vue?vue&type=template&id=56b6c734"
import script from "./EditForecast.vue?vue&type=script&lang=js"
export * from "./EditForecast.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__